import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../modal-service/modal.service';
import { ProductZoomComponent } from '../products/product-zoom/product-zoom.component';
import { ProductZoomModel } from './models/product-zoom-model';

@Injectable()
export class ProductZoomService {

  constructor(private modalService: ModalService,
    private translateService: TranslateService) { }

  showProductZoom(imgLink: string, btnText: string, targetClass?: string): Promise<boolean> {

    if (imgLink && imgLink.length > 0) {
      return this.openZoomModal(<ProductZoomModel>{
        imgLink: imgLink, btnText: btnText
      }, targetClass);
    }

    return new Promise((resolve, reject) => {
      resolve(true);
    });
  }

  private openZoomModal(productZoomModel: ProductZoomModel, targetClass?: string): Promise<boolean> {
    let customWindowClass = 'fastco-modal';
    if (targetClass !== undefined) {
      customWindowClass += ' ' + targetClass;
    }

    const modalRef = this.modalService.open(ProductZoomComponent,
      {
        windowClass: customWindowClass,
        backdrop: 'static'
      });

    (<ProductZoomComponent>modalRef.componentInstance).init(productZoomModel);
    return modalRef.result;
  }
}
